import React, { createContext, useState, useCallback } from 'react';
import ToastContainer from '../components/ToastContainer';

export const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = Date.now() + Math.random().toString(36).substr(2, 9);
    setToasts((prevToasts) => [...prevToasts, { id, message, type, duration }]);
  }, []);

  const toast = {
    success: useCallback((msg, duration) => addToast(msg, 'success', duration), [addToast]),
    error: useCallback((msg, duration) => addToast(msg, 'error', duration), [addToast]),
    info: useCallback((msg, duration) => addToast(msg, 'info', duration), [addToast]),
    warning: useCallback((msg, duration) => addToast(msg, 'warning', duration), [addToast]),
  };

  return (
    <ToastContext.Provider value={{ toast, toasts, removeToast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};
